<app-main-header
    [name_main]="urlOne?.name || 'Dashboard'"
    [variant]="'transparent'"
    [goBack]="true"
    [noSticky]="true">
    <div class="boards-header-actions">
        <ng-container *ngIf="selectedDashboard$ | async as dashboard">
            <div class="calendar" *ngIf="activeCalendar">

                <p class="error"
                    *ngIf="rangeForm.hasError('maxRangeExceeded') && (rangeForm.touched || rangeForm.dirty)">
                    El rango seleccionado no puede exceder los {{ rangeForm.getError('maxRangeExceeded').maxDays }}
                    días.
                </p>
                <p class="error"
                    *ngIf="rangeForm.get('start')?.hasError('required') && (rangeForm.get('start')?.touched || rangeForm.get('start')?.dirty)">
                    La fecha de inicio es requerida.
                </p>
                <p class="error"
                    *ngIf="rangeForm.get('end')?.hasError('required') && (rangeForm.get('end')?.touched || rangeForm.get('end')?.dirty)">
                    La fecha de fin es requerida.
                </p>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-date-range-input [formGroup]="rangeForm" [rangePicker]="picker" [min]="minDate"
                        [max]="maxDate">
                        <input matStartDate formControlName="start" placeholder="Fecha de inicio">
                        <input matEndDate formControlName="end" placeholder="Fecha de fin">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>


                </mat-form-field>
                <button mat-icon-button [disabled]="activeCalendarBtn"
                    (click)="downloadQueryGzip(dashboard, 'gestion')">
                    <span class="material-symbols-outlined">download</span>
                </button>

            </div>

        </ng-container>

        <mat-spinner *ngIf="downloadActive" [diameter]="30" [strokeWidth]="3" [color]="'primary'">
        </mat-spinner>
        @if(granular$().length > 0){
        <button #tooltip="matTooltip" matTooltip="Granular" class="back-btn" [matMenuTriggerFor]="menua" mat-icon-button
            [disabled]="isLoading">
            <span class="material-symbols-outlined">download</span>
        </button>
        }

        @if(gestion$().length > 0){
        <button #tooltip="matTooltip" matTooltip="Gestión" class="back-btn" [matMenuTriggerFor]="menu" mat-icon-button
            [disabled]="isLoading">
            <span class="material-symbols-outlined">dataset</span>
        </button>
        }
        @if(images$().length > 0){
        <button #tooltip="matTooltip" matTooltip="Imagenes" class="back-btn" [matMenuTriggerFor]="menub" mat-icon-button
            [disabled]="isLoading">
            <span class="material-symbols-outlined">image</span>
        </button>
        }
        @if(compe$().length > 0){
        <button #tooltip="matTooltip" matTooltip="Competencia" class="back-btn" [matMenuTriggerFor]="menuc"
            mat-icon-button [disabled]="isLoading">
            <span class="material-symbols-outlined">flowchart</span>
        </button>
        }


    </div>
    <mat-menu #menua="matMenu">
        @for(item of granular$(); track $index){
        <button mat-menu-item (click)="downloadQueryGzip(item, 'granular')" [disabled]="!item.active">
            <span>{{item.name}}</span>
        </button>
        }
    </mat-menu>
    <mat-menu #menu="matMenu">
        @for(item of gestion$(); track $index){
        <button mat-menu-item (click)="downloadQuery(item.host, item)" [disabled]="!item.active">
            <span>{{item.name}}</span>
        </button>
        }
    </mat-menu>
    <mat-menu #menub="matMenu">
        @for(item of images$(); track $index){
        <button mat-menu-item (click)="downloadQueryGzip(item, 'imagenes')" [disabled]="!item.active">
            <span>{{item.name}}</span>
        </button>
        }
    </mat-menu>
    <mat-menu #menuc="matMenu">
        @for(item of compe$(); track $index){
        <button mat-menu-item (click)="downloadQuery(item.host, item)" [disabled]="!item.active">
            <span>{{item.name}}</span>
        </button>
        }
    </mat-menu>
</app-main-header>
@if (boardsLoading || loading) {
  <section class="boards-skeleton">
    <div class="sk-row sk-row--top">
      <div class="sk-card sk-card--kpi"></div>
      <div class="sk-card sk-card--trend"></div>
    </div>
    <div class="sk-tabs">
      <span class="sk-pill"></span>
      <span class="sk-pill"></span>
      <span class="sk-pill"></span>
      <span class="sk-pill"></span>
    </div>
    <div class="sk-grid">
      <div class="sk-card sk-card--chart"></div>
      <div class="sk-card sk-card--chart"></div>
      <div class="sk-card sk-card--wide"></div>
      <div class="sk-card sk-card--chart"></div>
      <div class="sk-card sk-card--chart"></div>
    </div>
  </section>
} @else if (urlOne?.type === 'dynamic') {
  <app-dynamic-dashboard [boardId]="urlOne.configId ?? 'sdv-recognition'" />
} @else if (urlOne?.type === 'code') {
  <app-code-dashboard [boardId]="urlOne.id" />
} @else {
  <div class="powerbi-report-container">
    @if (missingUrlParams.length) {
      <p class="error">Este tablero requiere parámetros que no tienes asignados: {{ missingUrlParams.join(', ') }}.</p>
    } @else if (render) {
      <iframe [src]="render | safe" frameborder="0" allowFullScreen="true"></iframe>
    }
  </div>

  @if (metabaseRows.length > 0) {
  <div class="mission-parameters" style="margin-top: 16px; overflow-x: auto;">
      <h3>Datos Metabase (JSON)</h3>
      <table class="table table-sm table-striped" style="width: 100%; min-width: 600px;">
          <thead>
              <tr>
                  @for (column of metabaseColumns; track column) {
                  <th>{{ column }}</th>
                  }
              </tr>
          </thead>
          <tbody>
              @for (row of metabaseRows; track $index) {
              <tr>
                  @for (column of metabaseColumns; track column) {
                  <td>{{ row[column] }}</td>
                  }
              </tr>
              }
          </tbody>
      </table>
  </div>
  }
}
